import { AFFILIATE_PARTNER_ROUTE_PATHS } from "../../modules/affiliate/paths";
import { AGENT_ROUTE_PATHS, AGENT_ROUTE_PREFIX } from "../../modules/agent/paths";
import { CALC_BLACKLIST_ROUTE_PATHS } from "../../modules/calculator/blacklist/paths";
import { CALC_ROUTE_PATHS, CALC_ROUTE_PREFIX } from "../../modules/calculator/paths";
import { ADMIN_CALC_ROUTE_PATHS } from "../../modules/calculator/settings/paths";
import { CLIENT_ROUTE_PATHS, CLIENT_ROUTE_PREFIX } from "../../modules/client/paths";
import { COMMISSIONS_BATCH_ROUTE_PATHS } from "../../modules/commissions/batch/paths";
import { COMMISSIONS_LEVEL_ROUTE_PATHS } from "../../modules/commissions/level/paths";
import { COMMISSIONS_OUTPUTS_PATHS } from "../../modules/commissions/outputs/paths";
import { POSTPONED_COMMISSIONS_ROUTE_PATHS } from "../../modules/commissions/postponed/paths";
import { COMMISSION_PROMOTIONS_ROUTE_PATHS } from "../../modules/commissions/promotions/paths";
import { COMMISSIONS_SETTINGS_RANKS_ROUTE_PATHS } from "../../modules/commissions/ranks/paths";
import { SPLIT_COMMISSIONS_ROUTE_PATHS } from "../../modules/commissions/splitcommissions/paths";
import { COMPETITION_ROUTE_PATHS, COMPETITION_ROUTE_PREFIX } from "../../modules/competition/path";
import { COMPLICITY_ROUTE_PATHS } from "../../modules/complicity/paths";
import { CONTRACT_ROUTE_PATHS, CONTRACT_ROUTE_PREFIX } from "../../modules/contract/paths";
import { CONTRACT_UPDATE_ROUTE_PATHS } from "../../modules/contractupdate/paths";
import { COVERAGE_LIMIT_ROUTE_PATHS } from "../../modules/coveragelimit/paths";
import { DASHBOARD_ROUTE_PATHS } from "../../modules/dashboard/paths";
import { CONFIG_PROPERTY_ROUTE_PATHS } from "../../modules/dynamicconfig/paths";
import { FINANCIAL_MEDIATION_ROUTE_PATHS } from "../../modules/financialmediation/paths";
import { INSTITUTION_ROUTE_PATHS } from "../../modules/institution/paths";
import { JOB_ROUTE_PATHS } from "../../modules/jobs/paths";
import { LIFE_INSURENCE_TARIFF_ROUTE_PATHS } from "../../modules/lifeinsurancetariff/paths";
import { OVERVIEWS_ROUTE_PATHS, OVERVIEWS_ROUTE_PREFIX } from "../../modules/overviews/paths";
import { PARTNER_ROUTE_PATHS } from "../../modules/partner/paths";
import { PRODUCT_ROUTE_PATHS } from "../../modules/product/paths";
import { ADMIN_USER_ROUTE_PATHS, CURRENT_USER_ROUTE_PATHS } from "../../modules/user/paths";
import { VEHICLE_BRAND_ROUTE_PATHS } from "../../modules/vehicle/brand/paths";
import { VEHICLE_ENUM_ROUTE_PATHS } from "../../modules/vehicle/paths";
import { TopAgentType } from "../enums";
import { Permission } from "./enums";
import { PagePermissionsRule } from "./types";

export const DIVIDER_KEY = "-divider";
export const CONTRACT_REPORTS_DIVIDER_KEY = "/contract-reports" + DIVIDER_KEY;
export const CONTRACT_FORMS_DIVIDER_KEY = "/contract-forms" + DIVIDER_KEY;
export const AGENT_REPORTS_DIVIDER_KEY = "/agent-reports" + DIVIDER_KEY;
export const COMMISSIONS_SETTINGS_DIVIDER_KEY = "/commissions-settings" + DIVIDER_KEY;

export const SUBMENU_KEY = "-submenu";
export const COMMISSIONS_SUBMENU_KEY = "/commissions" + SUBMENU_KEY;
export const ADMIN_SUBMENU_KEY = "/admin" + SUBMENU_KEY;
export const SETTINGS_SUBMENU_KEY = "/settings" + SUBMENU_KEY;

export const pageRulePermissionsMap = new Map<string, PagePermissionsRule>([
  [
    DASHBOARD_ROUTE_PATHS.homepage.to,
    {
      permissions: [],
    },
  ],
  [
    COMPETITION_ROUTE_PREFIX + SUBMENU_KEY,
    {
      permissions: [Permission.AGENT_READ],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    COMPETITION_ROUTE_PATHS.china.to,
    {
      permissions: [Permission.AGENT_READ],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    COMPETITION_ROUTE_PATHS.slovenia.to,
    {
      permissions: [Permission.AGENT_READ],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    CURRENT_USER_ROUTE_PATHS.commissions.to,
    {
      permissions: [Permission.PROFILE_COMMISSIONS],
    },
  ],
  [
    CALC_ROUTE_PREFIX + SUBMENU_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.MTPL_CALCULATE,
        Permission.CRASH_CALCULATE,
        Permission.REALTY_CALCULATE,
        Permission.TRAVEL_CALCULATE,
      ],
    },
  ],
  [
    CALC_ROUTE_PATHS.vehicle.to,
    {
      isAnyPermissionRequired: true,
      permissions: [Permission.MTPL_CALCULATE, Permission.CRASH_CALCULATE],
    },
  ],
  [
    CALC_ROUTE_PATHS.vehicleDraft.to,
    {
      isAnyPermissionRequired: true,
      permissions: [Permission.MTPL_CALCULATE, Permission.CRASH_CALCULATE],
    },
  ],
  [
    CALC_ROUTE_PATHS.travel.to,
    {
      permissions: [Permission.TRAVEL_CALCULATE],
    },
  ],
  [
    CALC_ROUTE_PATHS.travelDraft.to,
    {
      permissions: [Permission.TRAVEL_CALCULATE],
    },
  ],
  [
    CALC_ROUTE_PATHS.realty.to,
    {
      permissions: [Permission.REALTY_CALCULATE],
    },
  ],
  [
    CALC_ROUTE_PATHS.realtyDraft.to,
    {
      permissions: [Permission.REALTY_CALCULATE],
    },
  ],
  [
    CALC_ROUTE_PATHS.records.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.ADMIN_MTPL_CALCULATORS,
        Permission.ADMIN_CRASH_CALCULATORS,
        Permission.ADMIN_REALTY_CALCULATORS,
        Permission.ADMIN_TRAVEL_CALCULATORS,
      ],
    },
  ],
  [
    PARTNER_ROUTE_PATHS.configs.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.PARTNER_INSURANCE_COMPANIES,
        Permission.PARTNER_BANKS,
        Permission.PARTNER_SECURITIES_BROKERS,
        Permission.PARTNER_BUILDING_SAVINGS_BANKS,
        Permission.PARTNER_MANAGERIAL_PENSION_COMPANIES,
        Permission.PARTNER_SUPPLEMENTARY_PENSION_COMPANIES,
        Permission.PARTNER_OTHERS,
      ],
    },
  ],
  [
    CLIENT_ROUTE_PREFIX + SUBMENU_KEY,
    {
      permissions: [Permission.CLIENT_READ],
    },
  ],
  [
    CLIENT_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.CLIENT_READ],
    },
  ],
  [
    CLIENT_ROUTE_PATHS.create.to,
    {
      permissions: [Permission.CLIENT_CREATE],
    },
  ],
  [
    CONTRACT_ROUTE_PREFIX + SUBMENU_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_READ,
        Permission.LOAN_READ,
        Permission.INVESTMENT_READ,
        Permission.DEPOSIT_READ,
        Permission.SECOND_PILLAR_READ,
        Permission.THIRD_PILLAR_READ,
        Permission.GENERIC_READ,
      ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.list.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_READ,
        Permission.LOAN_READ,
        Permission.INVESTMENT_READ,
        Permission.DEPOSIT_READ,
        Permission.SECOND_PILLAR_READ,
        Permission.THIRD_PILLAR_READ,
        Permission.GENERIC_READ,
      ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.create.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_CREATE,
        Permission.LOAN_CREATE,
        Permission.INVESTMENT_CREATE,
        Permission.DEPOSIT_CREATE,
        Permission.SECOND_PILLAR_CREATE,
        Permission.THIRD_PILLAR_CREATE,
        Permission.GENERIC_CREATE,
      ],
    },
  ],
  [
    CONTRACT_REPORTS_DIVIDER_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_READ,
        Permission.LOAN_READ,
        Permission.INVESTMENT_READ,
        Permission.DEPOSIT_READ,
        Permission.SECOND_PILLAR_READ,
        Permission.THIRD_PILLAR_READ,
        Permission.GENERIC_READ,
      ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.predictedCommissions.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_READ,
        Permission.LOAN_READ,
        Permission.INVESTMENT_READ,
        Permission.DEPOSIT_READ,
        Permission.SECOND_PILLAR_READ,
        Permission.THIRD_PILLAR_READ,
        Permission.GENERIC_READ,
      ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.anniversaryDate.to,
    {
      permissions: [Permission.INSURANCE_READ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.fixationAnniversaryDate.to,
    {
      permissions: [Permission.LOAN_READ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.unpaid.to,
    {
      permissions: [Permission.INSURANCE_READ],
    },
  ],
  [
    CONTRACT_FORMS_DIVIDER_KEY,
    {
      permissions: [Permission.INSURANCE_READ],
    },
  ],
  [
    CONTRACT_ROUTE_PATHS.forms.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_READ,
        Permission.LOAN_READ,
        Permission.DEPOSIT_READ,
        Permission.SECOND_PILLAR_READ,
        Permission.THIRD_PILLAR_READ,
      ],
    },
  ],
  [
    FINANCIAL_MEDIATION_ROUTE_PATHS.create.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.INSURANCE_CREATE,
        Permission.LOAN_CREATE,
        Permission.DEPOSIT_CREATE,
        Permission.SECOND_PILLAR_CREATE,
        Permission.THIRD_PILLAR_CREATE,
      ],
    },
  ],
  [
    AGENT_ROUTE_PREFIX + SUBMENU_KEY,
    {
      permissions: [Permission.AGENT_READ],
    },
  ],
  [
    AGENT_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.AGENT_READ],
    },
  ],
  [
    AGENT_ROUTE_PATHS.tree.to,
    {
      permissions: [Permission.AGENT_READ],
    },
  ],
  [
    AGENT_ROUTE_PATHS.create.to,
    {
      permissions: [Permission.AGENT_CREATE],
    },
  ],
  [
    AGENT_REPORTS_DIVIDER_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [Permission.AGENT_COMMISSIONS, Permission.AGENT_COMPETENCE],
    },
  ],
  [
    AGENT_ROUTE_PATHS.endingCompetences.to,
    {
      permissions: [Permission.AGENT_COMPETENCE],
    },
  ],
  [
    AGENT_ROUTE_PATHS.pointsReport.to,
    {
      permissions: [Permission.AGENT_COMMISSIONS],
    },
  ],
  [
    AGENT_ROUTE_PATHS.bailAccountsReport.to,
    {
      permissions: [Permission.AGENT_COMMISSIONS],
    },
  ],
  [
    AGENT_ROUTE_PATHS.debtAccountsReport.to,
    {
      permissions: [Permission.AGENT_COMMISSIONS],
    },
  ],
  [
    AGENT_ROUTE_PATHS.specialCommissionsReport.to,
    {
      permissions: [Permission.AGENT_COMMISSIONS],
    },
  ],
  [
    OVERVIEWS_ROUTE_PREFIX + SUBMENU_KEY,
    {
      permissions: [],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    OVERVIEWS_ROUTE_PATHS.businessCoefficients.to,
    {
      permissions: [Permission.AGENT_COMMISSIONS],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    OVERVIEWS_ROUTE_PATHS.investCombinations.to,
    {
      permissions: [],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    COMMISSIONS_SUBMENU_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [Permission.COMMISSIONS, Permission.POSTPONED_COMMISSIONS, Permission.TOP_AGENT_COMMISSIONS],
    },
  ],
  [
    COMMISSIONS_BATCH_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.COMMISSIONS],
    },
  ],
  [
    COMMISSIONS_OUTPUTS_PATHS.list.to,
    {
      permissions: [Permission.COMMISSIONS],
    },
  ],
  [
    POSTPONED_COMMISSIONS_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.POSTPONED_COMMISSIONS],
    },
  ],
  [
    SPLIT_COMMISSIONS_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.COMMISSIONS],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    COMMISSIONS_SETTINGS_DIVIDER_KEY,
    {
      permissions: [Permission.TOP_AGENT_COMMISSIONS],
    },
  ],
  [
    COMMISSIONS_LEVEL_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.TOP_AGENT_COMMISSIONS],
    },
  ],
  [
    COMMISSION_PROMOTIONS_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.TOP_AGENT_COMMISSIONS, Permission.AGENT_COMMISSIONS_SETTINGS],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    COMMISSIONS_SETTINGS_RANKS_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.TOP_AGENT_COMMISSIONS],
    },
  ],
  [
    ADMIN_SUBMENU_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.ADMIN_DASHBOARD,
        Permission.ADMIN_USERS,
        Permission.ADMIN_ENUMERATIONS,
        Permission.ADMIN_DOCUMENT_NODES,
        Permission.ADMIN_MTPL_CALCULATORS,
        Permission.ADMIN_CRASH_CALCULATORS,
        Permission.ADMIN_REALTY_CALCULATORS,
        Permission.ADMIN_TRAVEL_CALCULATORS,
        Permission.CLIENT_IMPORT,
        Permission.CONTRACT_IMPORT,
        Permission.AGENT_IMPORT,
      ],
    },
  ],
  [
    ADMIN_USER_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_USERS],
    },
  ],
  [
    ADMIN_USER_ROUTE_PATHS.create.to,
    {
      permissions: [Permission.ADMIN_USERS],
    },
  ],
  [
    INSTITUTION_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_ENUMERATIONS],
    },
  ],
  [
    INSTITUTION_ROUTE_PATHS.create.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    PRODUCT_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_ENUMERATIONS],
    },
  ],
  [
    AFFILIATE_PARTNER_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_ENUMERATIONS],
    },
  ],
  [
    AGENT_ROUTE_PATHS.directorates.to,
    {
      permissions: [Permission.ADMIN_ENUMERATIONS],
    },
  ],
  [
    AGENT_ROUTE_PATHS.education.to,
    {
      permissions: [Permission.ADMIN_ENUMERATIONS],
      allowedTopAgents: [TopAgentType.PLUS],
    },
  ],
  [
    ADMIN_CALC_ROUTE_PATHS.list.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.ADMIN_MTPL_CALCULATORS,
        Permission.ADMIN_CRASH_CALCULATORS,
        Permission.ADMIN_REALTY_CALCULATORS,
        Permission.ADMIN_TRAVEL_CALCULATORS,
      ],
    },
  ],
  [
    CONTRACT_UPDATE_ROUTE_PATHS.list.to,
    {
      isAnyPermissionRequired: true,
      permissions: [Permission.CLIENT_IMPORT, Permission.CONTRACT_IMPORT, Permission.AGENT_IMPORT],
    },
  ],
  [
    ADMIN_CALC_ROUTE_PATHS.create.to,
    {
      isAnyPermissionRequired: true,
      permissions: [
        Permission.ADMIN_MTPL_CALCULATORS,
        Permission.ADMIN_CRASH_CALCULATORS,
        Permission.ADMIN_REALTY_CALCULATORS,
        Permission.ADMIN_TRAVEL_CALCULATORS,
      ],
    },
  ],
  [
    SETTINGS_SUBMENU_KEY,
    {
      isAnyPermissionRequired: true,
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS, Permission.ADMIN_JOBS, Permission.ADMIN_SYSTEM_CONFIG],
    },
  ],
  [
    LIFE_INSURENCE_TARIFF_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    COVERAGE_LIMIT_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    COMPLICITY_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    VEHICLE_BRAND_ROUTE_PATHS.brands.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    VEHICLE_ENUM_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    JOB_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_JOBS],
    },
  ],
  [
    CALC_BLACKLIST_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_GLOBAL_ENUMERATIONS],
    },
  ],
  [
    CONFIG_PROPERTY_ROUTE_PATHS.list.to,
    {
      permissions: [Permission.ADMIN_SYSTEM_CONFIG],
    },
  ],
]);
